import React, { useEffect, useState } from 'react';

const LoadingBar = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      setProgress(0);
      const randomIncrement = () => {
        setProgress(prev => Math.min(prev + Math.random() * 10, 90));
      };
      const t = setInterval(randomIncrement, 300);
      return () => clearInterval(t);
    } else {
      setProgress(100);
      const t = setTimeout(() => setProgress(0), 500);
      return () => clearTimeout(t);
    }
  }, [isLoading]);

  if (progress === 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-1">
      <div 
        className="bg-primary-500 h-full transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default LoadingBar;
